/**
 * 导航栏类型常量
 */
export const NAV_TYPES = {
  MAIN: 'main',       // 主导航栏：首页、我的等一级页面
  MESSAGE: 'message', // 消息导航栏：Message/Follow切换
  CHAT: 'chat',       // 聊天导航栏：返回+头像+昵称
  VIP: 'vip', // VIP页面导航栏
  DIAMOND: 'diamond', // Diamond页面导航栏
  COMMON: 'common', // 通用导航栏：账号管理页面、设置密码页面、账号注销页面
  NONE: 'none',       // 无导航栏：全屏页面
}

/**
 * 所有有效的导航栏类型值
 */
export const VALID_NAV_TYPES = Object.values(NAV_TYPES)
